import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withPillNavigation from '../../shared/withPillNavigation.decorator';
import CompanyCodeSettings from './companyCodeSettings.component';
import TaxRates, { TaxRatesPropTypes } from './taxRates.component';
import TaxAccounting, { TaxAccountingPropTypes } from './taxAccounting.component';
import BookToTaxDifferences, { BookToTaxDifferencesPropTypes } from './bookToTaxDifferences.component';
import { CompanyCodeDetailsPropTypes } from '../../shared/propTypes/companyCodes';

const CalculationSettingsPillTypes = {
  COMPANY_CODE: 'COMPANY_CODE',
  TAX_RATES: 'TAX_RATES',
  BOOK_TO_TAX_DIFFERENCES: 'BOOK_TO_TAX_DIFFERENCES',
  TAX_ACCOUNTING: 'TAX_ACCOUNTING',
};

const CalculationSettingsPillDefinitions = [
  { label: 'Company Code', type: CalculationSettingsPillTypes.COMPANY_CODE },
  { label: 'Tax Rates', type: CalculationSettingsPillTypes.TAX_RATES },
  { label: 'Book to Tax Differences', type: CalculationSettingsPillTypes.BOOK_TO_TAX_DIFFERENCES },
  { label: 'Tax Accounting', type: CalculationSettingsPillTypes.TAX_ACCOUNTING },
];

class CalculationSettingsTab extends PureComponent {
  static propTypes = {
    companyCodeDetails: CompanyCodeDetailsPropTypes,
    taxRates: TaxRatesPropTypes,
    taxAccounting: TaxAccountingPropTypes,
    bookToTaxDifferences: BookToTaxDifferencesPropTypes,
    activePill: PropTypes.oneOf(Object.values(CalculationSettingsPillTypes)).isRequired,
  };

  contentRender() {
    const { companyCodeDetails, taxAccounting, bookToTaxDifferences, taxRates, activePill } = this.props;

    switch (activePill) {
      case CalculationSettingsPillTypes.COMPANY_CODE:
        return <CompanyCodeSettings companyCodeDetails={companyCodeDetails}/>;
      case CalculationSettingsPillTypes.TAX_RATES:
        return <TaxRates taxRates={taxRates} />;
      case CalculationSettingsPillTypes.TAX_ACCOUNTING:
        return <TaxAccounting taxAccounting={taxAccounting} />;
      case CalculationSettingsPillTypes.BOOK_TO_TAX_DIFFERENCES:
        return <BookToTaxDifferences bookToTaxDifferences={bookToTaxDifferences} />;
      default:
        return null;
    }
  }

  render() {
    return (
      <div className="calculation-settings-tab">
        {this.contentRender()}
      </div>
    );
  }
}

function mapStateToProps({ provision }) {
  return {
    companyCodeDetails: provision.general.companyCodeDetails,
    taxRates: provision.general.taxRates,
    taxAccounting: provision.general.taxAccounting,
    bookToTaxDifferences: provision.general.bookToTaxDifferences,
  };
}

export default connect(mapStateToProps)(
  withPillNavigation(
    () => CalculationSettingsPillDefinitions
  )(CalculationSettingsTab)
);
